module.exports = __webpack_public_path__ + "static/media/conwaysPic-min.91f4ee5e.png";